import styled from 'styled-components';
import { background, text, spacing, border, breakpoint, label } from '@carvana/ds-styles';
import Button from '@carvana/ds-button';
import Tabs from '@carvana/ds-tabs';
import Card from '@carvana/ds-card';

const StyledCard = styled(Card)`
  && {
    box-sizing: border-box;
    width: 100%;
    padding: ${spacing.xl};
    border: 1px solid ${border.weak};
    border-radius: 16px;
    background-color: ${background.default};
    max-width: 551px;

    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    justify-content: center;

    @media screen and (min-width: ${breakpoint.sm}) {
      padding: 0 ${spacing['3Xl']};
    }
  }
`;

const Container = styled.div`
  width: 100%;
  display: flex;
  align-items: stretch;
  flex-direction: column;
  gap: ${spacing['2Xl']};

  @media screen and (min-width: ${breakpoint.sm}) {
    gap: ${spacing['3Xl']};
  }
`;

const TabContainer = styled.div`
  width: 100%;
`;

const StyledTabBar = styled(Tabs.TabBar)`
  && {
    &.vehicle-entry {
      display: flex;
    }
    width: 100%;
    padding: 0;
    gap: 0;
    margin-bottom: ${spacing['3Xl']};
  }
`;

const StyledTab = styled(Tabs.Tab)`
  && {
    flex: 1;
    display: flex;
    height: 56px;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin: 0;
    color: ${text.default};
    border-bottom: 2px solid ${background.mutedSubtle};
    cursor: pointer;

    &.vehicle-entry {
      ${label.sm}
    }

    &[aria-selected='true'],
    &.active {
      color: ${text.strong};
      font-weight: 700;
      border-bottom-color: ${background.strong};
    }
  }
`;

const StyledTabPanel = styled(Tabs.TabPanel)`
  && {
    padding: 0;
  }
`;

const StyledButton = styled(Button)`
  && {
    align-self: stretch;
  }
`;

export {
  StyledCard,
  Container,
  TabContainer,
  StyledTabBar,
  StyledTab,
  StyledTabPanel,
  StyledButton
};
